import { render, staticRenderFns } from "./DocumentTabContent.vue?vue&type=template&id=13d977a7"
import script from "./DocumentTabContent.vue?vue&type=script&lang=js"
export * from "./DocumentTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports